import React, { useState } from "react";
import { useNotaire } from "../../context/NotaireContext";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { Description, Field, Label } from "../../components/catalyst/fieldset";
import { toast } from "react-toastify";

function PanelAdresse() {
  const context = useNotaire();
  const [adresse, setAdresse] = useState(null);
  const [adresse2, setAdresse2] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleAdresseChange = (val) => {
    setAdresse(val.label);
  };

  const handleAdresseSubmit = async (e) => {
    e.preventDefault();

    if (!adresse) {
      toast.error("Veuillez sélectionner une adresse");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `https://api.airtable.com/v0/appD48APNaGA4GN0B/etudes/${context.infoEtude.id}`,
        {
          method: "PATCH",
          headers: {
             Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                        Accept: "application/json",
                        "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fields: { adresse },
          }),
        }
      );

      if (response.ok) {
        toast.success("Adresse mise à jour !");
      } else {
        const errText = await response.text();
        console.error("Erreur Airtable:", errText);
        toast.error("Erreur lors de la mise à jour de l'adresse.");
      }
    } catch (err) {
      console.error("Erreur réseau:", err);
      toast.error("❌ Erreur réseau");
    } finally {
      setLoading(false);
    }
  };

   const handleAdresseSubmit2 = async (e) => {
    e.preventDefault();

    if (!adresse) {
      toast.error("Veuillez sélectionner une adresse");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `https://api.airtable.com/v0/appD48APNaGA4GN0B/etudes/${context.infoEtude.id}`,
        {
          method: "PATCH",
          headers: {
             Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                        Accept: "application/json",
                        "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fields: { adresse },
          }),
        }
      );

      if (response.ok) {
        toast.success("Adresse mise à jour !");
      } else {
        const errText = await response.text();
        console.error("Erreur Airtable:", errText);
        toast.error("Erreur lors de la mise à jour de l'adresse.");
      }
    } catch (err) {
      console.error("Erreur réseau:", err);
      toast.error("❌ Erreur réseau");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow mt-8">
      <form onSubmit={handleAdresseSubmit} className="space-y-4">
        <Field>
          <Label>Adresse de votre étude</Label>
          <GooglePlacesAutocomplete
            apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
            
            selectProps={{
              defaultInputValue: context.infoEtude.adresse,
              onChange: handleAdresseChange,
              placeholder: context.infoEtude.adresse || "Entrez votre adresse",
             
            }}
          />
        </Field>

        <button
          type="submit"
          className="btn-primary mt-4"
          disabled={loading}
        >
          {loading ? "Mise à jour..." : "Modifier l’adresse"}
        </button>
      </form>

      {/** si deux adresse */}
      {context.user.adresse_from_etudes.length === 2 && <>

      <form className="space-y-4 mt-10">
        <Field>
          <Label>Seconde Adresse</Label>
          <Description>Non modifiable, veuillez nous contacter via le chat pour modifier cette adresse</Description>
          <GooglePlacesAutocomplete
            apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
            disabled
            selectProps={{
              defaultInputValue: context.user.adresse_from_etudes[0],
              onChange: handleAdresseChange,
              placeholder: context.user.adresse_from_etudes[0] || "Entrez votre adresse",
            }}
          />
        </Field>
      </form>
      
      </>}
    </div>
  );
}

export default PanelAdresse;